/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentDetailsFormRemoveShipper: "shipment-details-form-remove-shipper",
  shipmentDetailsFormAddShipper: "shipment-details-form-add-shipper",
  shipmentDetailsFormRemoveReceiver: "shipment-details-form-remove-receiver",
  shipmentDetailsFormNumberOfOrdersPerDay: "shipment-details-form-number-of-orders-per-day",
} as const;
